import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = {
  key: 0,
  class: "page-alarmsystem position-relative form-custom"
}
const _hoisted_4 = { class: "p-field" }
const _hoisted_5 = { class: "p-field-label" }
const _hoisted_6 = { class: "alarmsytem-section" }
const _hoisted_7 = { class: "p-field mt-4" }
const _hoisted_8 = { class: "p-field-label" }
const _hoisted_9 = { class: "alarmsytem-section" }
const _hoisted_10 = { class: "list-unstyled" }
const _hoisted_11 = { class: "p-field mt-4" }
const _hoisted_12 = { class: "p-field-label" }
const _hoisted_13 = { class: "alarmsytem-section" }
const _hoisted_14 = { class: "list-unstyled" }
const _hoisted_15 = { class: "p-field mt-4" }
const _hoisted_16 = { class: "p-field-label" }
const _hoisted_17 = { class: "alarmsytem-section" }
const _hoisted_18 = { class: "p-field mt-4" }
const _hoisted_19 = { class: "p-field-label" }
const _hoisted_20 = { class: "alarmsytem-section" }
const _hoisted_21 = { class: "list-unstyled" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode("div", null, [
        _createVNode(_component_router_link, {
          to: _ctx.backLink,
          class: "fs-18 text-decoration-none text-gray"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.currentPlant.name), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.Alarmsystem")), 1)
      ])
    ]),
    (_ctx.alarmsystem)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.AlarmStatusTitleUpper")), 1),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_InlineSvgScoped, {
                class: "text-success mr-2 alarm-icon",
                src: 
                        require(`@/assets/images/icons/icon-confirm-outline.svg`)
                    ,
                "aria-label": "icon-alarm"
              }, null, 8, ["src"]),
              _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.AlarmStatusOperative")), 1)
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("AppResource.AlarmStatusPartitionTitleUpper")), 1),
            _createVNode("div", _hoisted_9, [
              _createVNode("ul", _hoisted_10, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.alarmsystem.partitions, (partition) => {
                  return (_openBlock(), _createBlock("li", {
                    key: partition.partitionId
                  }, _toDisplayString(partition.partitionName), 1))
                }), 128))
              ])
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("AppResource.AlarmStatusSceneTitleUpper")), 1),
            _createVNode("div", _hoisted_13, [
              _createVNode("ul", _hoisted_14, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.alarmsystem.scenes, (scene) => {
                  return (_openBlock(), _createBlock("li", {
                    key: scene.sceneId
                  }, _toDisplayString(scene.sceneName), 1))
                }), 128))
              ])
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("AppResource.AlarmStatusRoomTitleUpper")), 1),
            _createVNode("div", _hoisted_17, _toDisplayString(_ctx.alarmsystem.roomName), 1)
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("AppResource.AlarmStatusSensorTitleUpper")), 1),
            _createVNode("div", _hoisted_20, [
              _createVNode("ul", _hoisted_21, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.alarmsystem.sensors, (sensor) => {
                  return (_openBlock(), _createBlock("li", {
                    key: sensor.sensorAddress
                  }, _toDisplayString(sensor.sensorName) + " - " + _toDisplayString(sensor.roomName), 1))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}